import Add from './HydrationAddButton';

const HydrationAddContainer = ({ unit, add, messages }) => {
  const mililiterButtons = [250, 1000];
  const centyliterButtons = [25, 100];
  const ounceButtons = [8, 32];

  let buttons;

  if (unit === 'ml') {
    buttons = mililiterButtons;
  } else if (unit === 'cl') {
    buttons = centyliterButtons;
  } else if (unit === 'oz') {
    buttons = ounceButtons;
  } else {
    throw new Error(`Unsupported unit: ${this.props.unit}`);
  }

  return (
    <div className="text-center d-flex mb-xl">
      <Add value={buttons[0]} unit={unit} messages={messages} add={add} />

      <Add value={buttons[1]} unit={unit} messages={messages} add={add} className="mx-2" />

      <Add value={null} unit={unit} messages={messages} add={add} />
    </div>
  );
};

export default HydrationAddContainer;
